export const constant = {
	selector: {
		target: 'data-m-activator',
		handler: 'data-m-activator-handler',
		fullPageHandler: 'data-m-activator-full-page-handler',
	},
}
